import { Route } from 'vue-router';
import DesignScenario from '@/modules/design/views/components/DesignScenarioContainer.vue';

import AsphaltScenarioInfo from '@/modules/design/views/asphalt/1-AsphaltScenarioInfo.vue';
import AsphaltDesignParameters from '@/modules/design/views/asphalt/2-AsphaltDesignParameters.vue';
import AsphaltTraffic from '@/modules/design/views/asphalt/3-AsphaltTraffic.vue';
import AsphaltStructure from '@/modules/design/views/asphalt/4-AsphaltStructure.vue';
import AsphaltSubstructure from '@/modules/design/views/asphalt/5-AsphaltSubstructure.vue';
import AsphaltReport from '@/modules/design/views/asphalt/6-AsphaltReport.vue';

import ConcreteScenarioInfo from '@/modules/design/views/concrete/1-ConcreteScenarioInfo.vue';
import ConcreteDesignParameters from '@/modules/design/views/concrete/2-ConcreteDesignParameters.vue';
import ConcreteTraffic from '@/modules/design/views/concrete/3-ConcreteTraffic.vue';
import ConcreteStructure from '@/modules/design/views/concrete/4-ConcreteStructure.vue';
import ConcreteSubstructure from '@/modules/design/views/concrete/5-ConcreteSubstructure.vue';
import ConcreteReport from '@/modules/design/views/concrete/6-ConcreteReport.vue';


import PorousScenarioInfo from '@/modules/design/views/porous/1-PorousScenarioInfo.vue';
import PorousDesignParameters from '@/modules/design/views/porous/3-PorousDesignParameters.vue';
import PorousLayers from '@/modules/design/views/porous/2-PorousLayers.vue';
import PorousReport from '@/modules/design/views/porous/5-PorousReport.vue';
import PorousTraffic from '@/modules/design/views/porous/4-PorousTraffic.vue';

import AcOverlayScenarioInfo from '@/modules/design/views/acOverlay/1-AcOverlayScenarioInfo.vue';
import AcOverlayLayers from '@/modules/design/views/acOverlay/2-AcOverlayLayers.vue';
import AcOverlayStructuralEvaluation from '@/modules/design/views/acOverlay/4-AcOverlayStructuralEvaluation.vue';
import AcOverlayTraffic from '@/modules/design/views/acOverlay/5-AcOverlayTraffic.vue';
import AcOverlayDesignParameters from '@/modules/design/views/acOverlay/3-AcOverlayDesignParameters.vue';
import AcOverlayReport from '@/modules/design/views/acOverlay/6-AcOverlayReport.vue';


export const asphaltPages = [
  { link: '1', text: 'Scenario Information' },
  { link: '2', text: 'Design Parameters' },
  { link: '3', text: 'Traffic & Loading' },
  { link: '4', text: 'Pavement Structure' },
  { link: '5', text: 'Substructure' },
  { link: '6', text: 'Design Guidance' },
];

export const asphaltRoutes = {
  path: '/projects/asphalt/:pxDesignId',
  name: 'asphalt',
  redirect: '/projects/asphalt/:pxDesignId/1',
  component: DesignScenario,
  props: (route: Route) => ({
    pxDesignId: route.params.pxDesignId,
    designScenarioType: 'asphalt',
    pages: asphaltPages,
  }),
  children: [
    {
      path: '1',
      component: AsphaltScenarioInfo,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'asphalt', page: 1 }),
    },
    {
      path: '2',
      component: AsphaltDesignParameters,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'asphalt', page: 2 }),
    },
    {
      path: '3',
      component: AsphaltTraffic,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'asphalt', page: 3 }),
    },
    {
      path: '4',
      component: AsphaltStructure,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'asphalt', page: 4 }),
    },
    {
      path: '5',
      component: AsphaltSubstructure,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'asphalt', page: 5 }),
    },
    {
      path: '6',
      component: AsphaltReport,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'asphalt', page: 6 }),
    },
  ],
};

export const concretePages = [
  { link: '1', text: 'Scenario Information' },
  { link: '2', text: 'Design Parameters' },
  { link: '3', text: 'Traffic & Loading' },
  { link: '4', text: 'Pavement Structure' },
  { link: '5', text: 'Substructure' },
  { link: '6', text: 'Design Guidance' },
];

export const concreteRoutes = {
  path: '/projects/concrete/:pxDesignId',
  redirect: '/projects/concrete/:pxDesignId/1',
  component: DesignScenario,
  props: (route: Route) => ({
    pxDesignId: route.params.pxDesignId,
    designScenarioType: 'concrete',
    pages: concretePages,
  }),
  children: [
    {
      path: '1',
      component: ConcreteScenarioInfo,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'concrete', page: 1 }),
    },
    {
      path: '2',
      component: ConcreteDesignParameters,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'concrete', page: 2 }),
    },
    {
      path: '3',
      component: ConcreteTraffic,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'concrete', page: 3 }),
    },
    {
      path: '4',
      component: ConcreteStructure,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'concrete', page: 4 }),
    },
    {
      path: '5',
      component: ConcreteSubstructure,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'concrete', page: 5 }),
    },
    {
      path: '6',
      component: ConcreteReport,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'concrete', page: 6 }),
    },
  ],
};

export const porousPages = [
  { link: '1', text: 'Scenario Information' },
  { link: '2', text: 'Layers' },
  { link: '3', text: 'Design Parameters' },
  { link: '4', text: 'Traffic & Loading' },
  { link: '5', text: 'Design Guidance' },
];

export const porousRoutes = {
  path: '/projects/porous/:pxDesignId',
  redirect: '/projects/porous/:pxDesignId/1',
  component: DesignScenario,
  props: (route: Route) => ({
    pxDesignId: route.params.pxDesignId,
    designScenarioType: 'porous',
    pages: porousPages,
  }),
  children: [
    {
      path: '1',
      component: PorousScenarioInfo,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'porous', page: 1 }),
    },
    {
      path: '2',
      component: PorousLayers,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'porous', page: 2 }),
    },
    {
      path: '3',
      component: PorousDesignParameters,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'porous', page: 3 }),
    },
    {
      path: '4',
      component: PorousTraffic,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'porous', page: 4 }),
    },
    {
      path: '5',
      component: PorousReport,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'porous', page: 5 }),
    },
  ],
};

export const acOverlayPages = [
  { link: '1', text: 'Scenario Information' },
  { link: '2', text: 'Layers' },
  { link: '3', text: 'Design Parameters' },
  { link: '4', text: 'Structural Evaluation' },
  { link: '5', text: 'Traffic & Loading' },
  { link: '6', text: 'Design Guidance' },
];

export const acOverlayRoutes = {
  path: '/projects/ac-overlay/:pxDesignId',
  redirect: '/projects/ac-overlay/:pxDesignId/1',
  component: DesignScenario,
  props: (route: Route) => ({
    pxDesignId: route.params.pxDesignId,
    designScenarioType: 'acOverlay',
    pages: acOverlayPages,
  }),
  children: [
    {
      path: '1',
      component: AcOverlayScenarioInfo,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'acOverlay', page: 1 }),
    },
    {
      path: '2',
      component: AcOverlayLayers,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'acOverlay', page: 2 }),
    },
    {
      path: '3',
      component: AcOverlayDesignParameters,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'acOverlay', page: 3 }),
    },
    {
      path: '4',
      component: AcOverlayStructuralEvaluation,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'acOverlay', page: 4 }),
    },
    {
      path: '5',
      component: AcOverlayTraffic,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'acOverlay', page: 5 }),
    },
    {
      path: '6',
      component: AcOverlayReport,
      props: (route: Route) => ({ pxDesignId: route.params.pxDesignId, designScenarioType: 'acOverlay', page: 6 }),
    },
  ],
};
